import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    algType: 'GENERAL',
    mapProp: 'algMap',
    textProp: 'algTitle',
}
